"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var NotificationModule = /*#__PURE__*/function () {
  function NotificationModule() {
    _classCallCheck(this, NotificationModule);

    this.state$ = new NotificationModule.State();
  }

  _createClass(NotificationModule, [{
    key: "publish",
    value: function publish(type, payload) {
      this.state$.next({
        type: type,
        payload: payload
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(subject) {
      var _this = this;

      var subscription = subject.subscribe({
        next: function next(value) {
          return _this.state$.next(value);
        },
        complete: function complete() {
          return subscription.unsubscribe();
        }
      });
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }]);

  return NotificationModule;
}();

exports.NotificationModule = NotificationModule;

(function (NotificationModule) {
  var State = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State, _utils_1$StateSubject);

    var _super = _createSuper(State);

    function State() {
      _classCallCheck(this, State);

      return _super.call(this);
    }

    return State;
  }(utils_1.StateSubject);

  NotificationModule.State = State;
})(NotificationModule = exports.NotificationModule || (exports.NotificationModule = {}));